import { registerPlugin } from '@capacitor/core';
const CairnCompass = registerPlugin('CairnCompass', {
    web: () => import('./web').then(m => new m.CairnCompassWeb()),
});
export * from './definitions';
export { CairnCompass };
